import { useCallback, useEffect, useMemo, useState } from 'react';

import styles from './WelcomeAdmin.module.scss';
import './WelcomeAdmin.scss';
import { DropdownOption } from '../../models/common/DropdownOption';
import { DefaultInfoResponseModel } from '../../models/defaultInfos/DefaultInfoResponseModel';
import { HttpService, IHttpService } from './../../services/httpService';
import {
	INotifierService,
	NotifierService
} from './../../services/notifierService';
import { Dropdown } from 'primereact/dropdown';
import ReactQuill from 'react-quill';

const WelcomeAdmin = (): JSX.Element => {
	const [divisionsOptions, setDivisionsOptions] = useState<DropdownOption[]>(
		[]
	);

	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [shouldReload, setShouldReload] = useState<boolean>(false);

	const [selectedDivisionId, setSelectedDivisionId] = useState<number>(1);

	const [defaultInfoDetails, setDefaultInfoDetails] =
		useState<DefaultInfoResponseModel>({
			id: 0,
			divisionId: 0,
			body: ''
		});

	const [body, setBody] = useState<string>('');

	const httpService: IHttpService = useMemo(() => new HttpService(), []);
	const notifierService: INotifierService = useMemo(
		() => new NotifierService(),
		[]
	);

	const fetchDivisions = useCallback(() => {
		httpService
			.get<DropdownOption[]>('divisions/dropdown', undefined)
			.then((options) => setDivisionsOptions(options))
			.catch((err) => notifierService.error());
	}, [httpService, notifierService]);

	const fetchDefaultInfo = useCallback(() => {
		httpService
			.get<DefaultInfoResponseModel>(
				`defaultInfos/${selectedDivisionId}`,
				undefined
			)
			.then((defaultInfo) => {
				setDefaultInfoDetails(defaultInfo);
				setBody(defaultInfo.body);
			})
			.catch((err) => notifierService.error());
	}, [selectedDivisionId, httpService, notifierService]);

	useEffect(() => {
		fetchDivisions();
	}, [fetchDivisions]);

	useEffect(() => {
		fetchDefaultInfo();
	}, [selectedDivisionId, fetchDefaultInfo]);

	useEffect(() => {
		if (shouldReload) {
			fetchDefaultInfo();
			setShouldReload(false);
		}
	}, [shouldReload, fetchDefaultInfo]);

	const handleEditDefaultInfo = async (): Promise<void> => {
		if (!body) {
			return;
		}

		setIsLoading(true);

		try {
			await httpService.put(
				`defaultInfos/${defaultInfoDetails.id}`,
				JSON.stringify({ body }),
				undefined,
				false
			);

			setShouldReload(true);

			notifierService.info('Welcome page was edited');
		} catch (err) {
			notifierService.error(err);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<div className={styles.container}>
				<div className={styles.inputsContainer}>
					<div className={styles.content}>
						<label htmlFor='division'>Division</label>
						<Dropdown
							id='division'
							value={selectedDivisionId}
							options={divisionsOptions}
							onChange={(e) => {
								setSelectedDivisionId(e.target.value);
							}}
						/>
					</div>

					<div className={styles.content}>
						<label htmlFor='body'>Welcome screen message</label>
						<ReactQuill
							className='editor'
							value={body}
							onChange={(e) => setBody(e ?? '')}
							modules={{
								clipboard: {
									matchVisual: false
								}
							}}
						/>
					</div>
				</div>

				<button
					className='btn primary'
					disabled={isLoading}
					onClick={handleEditDefaultInfo}
				>
					Save
				</button>
			</div>
		</>
	);
};

export default WelcomeAdmin;
